<script setup lang="ts">
import { computed } from 'vue'
import { useOrg } from '@/composables/useApi'
import { api } from '@/lib/api'

const { data: org, loading } = useOrg()

const trialStatus = computed(() => org.value?.trial?.status ?? 'active')
const daysRemaining = computed(() => org.value?.trial?.daysRemaining ?? 0)

const showBanner = computed(() => {
  if (loading.value || !org.value?.trial) return false
  return trialStatus.value === 'trialing' || trialStatus.value === 'expired'
})

const isExpired = computed(() => trialStatus.value === 'expired')

async function handleSubscribe() {
  try {
    const currentUrl = window.location.href
    const res = await api.createCheckout({
      plan: 'starter',
      successUrl: currentUrl,
      cancelUrl: currentUrl,
    })
    if (res.url) {
      window.location.href = res.url
    }
  } catch (e) {
    // checkout session failed — stay on current page
  }
}
</script>

<template>
  <div v-if="showBanner" :class="[
    'flex items-center justify-between gap-md px-md py-sm rounded-md mb-md',
    isExpired
      ? 'bg-error/10 border border-error/20'
      : 'bg-warning/10 border border-warning/20'
  ]">
    <div class="flex items-center gap-sm">
      <svg v-if="isExpired" class="w-4 h-4 text-error flex-shrink-0" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
      </svg>
      <svg v-else class="w-4 h-4 text-warning flex-shrink-0" viewBox="0 0 24 24" fill="currentColor">
        <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z" />
      </svg>
      <span :class="[
        'text-body-sm font-body',
        isExpired ? 'text-error' : 'text-warning'
      ]">
        <template v-if="isExpired">
          Your free trial has expired. Subscribe to continue using FlagDrop.
        </template>
        <template v-else>
          Trial: {{ daysRemaining }} day{{ daysRemaining === 1 ? '' : 's' }} remaining
        </template>
      </span>
    </div>
    <div class="flex items-center gap-sm">
      <router-link
        to="/billing"
        class="text-body-sm font-body underline whitespace-nowrap"
        :class="isExpired ? 'text-error' : 'text-warning'"
      >
        Upgrade
      </router-link>
      <button
        class="btn-primary !py-xs !px-sm !text-label-sm whitespace-nowrap"
        @click="handleSubscribe"
      >
        Subscribe
      </button>
    </div>
  </div>
</template>
